import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "ExternalStepError", "$reason$ $reason_details$", config.defaultMessageId)